import type { EUserRoles } from '../enums/EUserRoles';

export type Role = 'user' | 'admin' | 'staff' | 'portfolioManager';

export const USER_ACCOUNT_ROLE_OPTIONS: Array<{ value: Role; label: string }> = [
  { value: 'user', label: 'user' },
  { value: 'staff', label: 'staff' },
  { value: 'admin', label: 'admin' },
  { value: 'portfolioManager', label: 'portfolio manager' }
];

interface UserAccountModel {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: Role;
  twoFaRequired: boolean;
  twoFaUri?: string;
}

export interface CreateKeycloakUserModel {
  firstName: string;
  lastName: string;
  email: string;
  roles: [string];
  totp: boolean;
}

export interface UpdateInfoPayload {
  firstName?: string;
  lastName?: string;
  email: string;
  role?: Role | EUserRoles[];
}

/**
 * @deprecated. Use CoreJsonAPIService instead.
 */
export type DeleteSelfResponse = { message: string } | { error: string };

export default UserAccountModel;
